import { businessKey } from 'queryKeys';

const CREATIVES_DASHBOARD = 'creatives-dashboard';

export const cdQuery = businessKey.query(CREATIVES_DASHBOARD);
export const grid = cdQuery.grid();

export const metrics = cdQuery.exact('metrics');
export const dimensions = cdQuery.exact('dimensions');
